import { type FC, useCallback } from 'react';
import { ButtonClose, ButtonFullScreen } from '@/components/buttons';
import { useUserWageringBonuses } from '@/hooks/bonuses';
import { useGameOpenFlow } from '@/hooks/game';
import { useGetCommonStore } from '@/store';
import { FavoriteButton } from '../components/FavoriteButton';
import { ToggleDemoSwitch } from '../components/ToggleDemoSwitch';
import { WagerLabel } from '../components/WagerLabel';
import type {
  ActionsPanelBasicProps,
  DesktopActionsPanelProps,
  GameStateActions,
} from '../types';
import { ScActionsPanel } from './styled';

export const ActionsPanelDesktop: FC<
  DesktopActionsPanelProps & ActionsPanelBasicProps & GameStateActions
> = ({
  isDemo,
  isFullScreen,
  onFullScreen,
  isFavorite,
  handleFavorite,
  handleToggleDemo,
  isDemoAvailable,
}) => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const { closeGameFlow } = useGameOpenFlow();

  const handleGoBack = useCallback(() => {
    if (isFullScreen) {
      onFullScreen();
    } else {
      closeGameFlow();
    }

    // TODO: popups
    // handleTrigger(PopupTrigger.GAME_EXIT);
  }, [closeGameFlow, isFullScreen, onFullScreen]);

  const { hasWageringBonusByCurrency } = useUserWageringBonuses();

  return (
    <ScActionsPanel isFullScreen={isFullScreen}>
      <div className="btn__wrapper btn__close">
        <ButtonClose onClick={handleGoBack} />
      </div>
      <div className="btn__wrapper">
        <ButtonFullScreen onClick={onFullScreen} />
      </div>
      {isAuthenticated && (
        <FavoriteButton
          handleFavorite={handleFavorite}
          isFavorite={isFavorite}
        />
      )}
      {hasWageringBonusByCurrency && !isDemo && <WagerLabel />}
      <div className="toggle__wrapper">
        <ToggleDemoSwitch
          handleToggleDemo={handleToggleDemo}
          isDemo={isDemo}
          isDemoAvailable={isDemoAvailable}
        />
      </div>
    </ScActionsPanel>
  );
};
